import { useEffect } from 'react';
import PageShell from '@/components/feature/PageShell';
import SectionShell from '@/components/feature/SectionShell';
import SectionHeader, { microCls } from '@/components/feature/SectionHeader';
import InquiryForm from '@/pages/home/components/InquiryForm';
import { studio } from '@/mocks/projects';
import Reveal, { RevealGroup, moDelay } from '@/lib/motion/Reveal';

const groups = [
  { k: 'Location', v: 'Berlin / Lisbon' },
  { k: 'Availability', v: 'Available for travel / worldwide assignments' },
  { k: 'Response', v: 'Replies within two business days' },
];

export default function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Contact — Maren Voss Photography, Berlin & Lisbon';
  }, []);

  return (
    <PageShell>
      <SectionShell labelledBy="contact-page-title" className="!border-t-0">
        <SectionHeader as="h1" index="01" name="Contact" titleId="contact-page-title" title="Tell me about the project." meta="Commissions 2026–2027" />
        <div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-[31fr_8fr_61fr] lg:gap-0">
          <RevealGroup as="aside" className="flex flex-col gap-9 lg:col-start-1">
            <div className="mo-item mo--info" style={moDelay(0, 0, 50)}>
              <p className={`${microCls} text-foreground-500`}>New work</p>
              <p className="mt-4 max-w-xs font-heading text-[22px] font-medium leading-[1.25] tracking-[-0.015em] text-foreground-950">
                Campaigns, portraits and commercial commissions.
              </p>
            </div>
            {groups.map((g, i) => (
              <div key={g.k} className="mo-item mo--info" style={moDelay(0, i + 1, 50)}>
                <p className={`${microCls} text-foreground-500`}>{g.k}</p>
                <p className="mt-3 max-w-[260px] text-[15px] leading-relaxed text-foreground-950">{g.v}</p>
              </div>
            ))}
            <div className="mo-item mo--info" style={moDelay(0, groups.length + 1, 50)}>
              <p className={`${microCls} text-foreground-500`}>Email</p>
              <a href={`mailto:${studio.email}`} className="mt-3 inline-block border-b border-foreground-950 pb-0.5 text-[15px] text-foreground-950 transition-opacity hover:opacity-55 cursor-pointer">{studio.email}</a>
            </div>
          </RevealGroup>
          <Reveal variant="block" delay={80} className="lg:col-start-3">
            <InquiryForm />
          </Reveal>
        </div>
      </SectionShell>
    </PageShell>
  );
}